import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { Link as RouterLink } from "react-router-dom";

export const PageFooter = () => (
  <Paper elevation={0} square component="footer" sx={{ py: 3, mt: "auto" }}>
    <Container maxWidth="lg">
      <Stack direction="row" spacing={3} justifyContent="center">
        <Link component={RouterLink} to="/impressum" color="inherit" underline="hover">
          Impressum
        </Link>
        <Link component={RouterLink} to="/datenschutz" color="inherit" underline="hover">
          Datenschutzerklärung
        </Link>
      </Stack>
    </Container>
  </Paper>
);
